import React, { memo } from "react";
import { HappycoWorkOrderFragment } from "gql/graphql";
import { Text } from "@chakra-ui/react";
import { toTitleCase } from "modules/utils/Functions";
import colors from "app/colors";

interface IProps {
  happycoWorkOrder: HappycoWorkOrderFragment;
}

const HappycoWorkOrderType = ({ happycoWorkOrder }: IProps) => {
  if (!happycoWorkOrder.type) {
    return null;
  }

  return (
    <Text
      fontSize={9}
      fontWeight={700}
      color={colors.gray50}
      noOfLines={1}
      w="fit-content"
      borderRadius="2px"
      borderColor={colors.grayPrimary}
      borderWidth={1}
      px="2px"
      py="1px"
    >
      {toTitleCase(happycoWorkOrder.type)}
    </Text>
  );
};

export default memo(HappycoWorkOrderType);
